import React from 'react';
import { motion } from 'framer-motion';
export function BrandPortfolio() {
  const brands = [{
    name: 'Agha Noor',
    url: 'aghanoorofficial.com',
    industry: "Luxury Women's Fashion",
    work: 'Ecommerce design & development'
  }, {
    name: 'A1 Spices',
    url: 'a1spices.com',
    industry: 'B2B Food & Spices',
    work: 'Website design & development'
  }, {
    name: 'Tressano',
    url: 'tressano.com',
    industry: 'Fashion & Lifestyle',
    work: 'Ecommerce store development'
  }, {
    name: 'Nakoosh',
    url: 'nakoosh.com',
    industry: "Women's Fashion",
    work: 'Ecommerce store design'
  }, {
    name: 'Amor Beautee',
    url: 'amorbeautee.com',
    industry: 'Beauty & Skincare',
    work: 'Ecommerce store development'
  }, {
    name: 'Always Sunday',
    url: 'alwayssunday.store',
    industry: 'Home & Lifestyle (UK)',
    work: 'Shopify store development'
  }, {
    name: 'PaceTech',
    url: 'pacetech.com',
    industry: 'Technology',
    work: 'Website design & development'
  }, {
    name: 'Al Soufi',
    url: 'alsoufi.biz',
    industry: 'Business Services (UAE)',
    work: 'Website design & development'
  }, {
    name: 'KGTL',
    url: 'kgtl.com.pk',
    industry: 'Corporate',
    work: 'Website design & development'
  }];
  return <section className="py-20 bg-gray-50 border-y border-gray-100" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-navy" data-id="element-16">
            More Brands We've Worked With
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
          {brands.map((brand, index) => <motion.a key={index} href={`https://${brand.url}`} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-teal/30 transition-all group flex flex-col h-full" data-id="element-18">
              <div className="flex justify-between items-start mb-4" data-id="element-19">
                <h3 className="text-lg font-bold text-navy group-hover:text-teal transition-colors" data-id="element-20">
                  {brand.name}
                </h3>
                <span className="text-xs font-medium text-gray-400 bg-gray-50 px-2 py-1 rounded" data-id="element-21">
                  {brand.url}
                </span>
              </div>
              <div className="mt-auto" data-id="element-22">
                <p className="text-xs font-semibold text-teal uppercase tracking-wider mb-1" data-id="element-23">
                  {brand.industry}
                </p>
                <p className="text-sm text-gray-600" data-id="element-24">{brand.work}</p>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}